import { TicketState } from "../interfaces/ticket"
import { Types } from "../types"
import { TicketActions } from "../types/ticket/actionTypes"


const initialState: TicketState = {
    getTicketPending: false,
    getTicketSuccess: false,
    getTicketError: '',
    data: [],


    registerTicketPending: false,
    registerTicketSuccess: false,
    registerTicketError: '',

    getTicketByUserIdPending: false,
    getTicketByUserIdSuccess: false,
    getTicketByUserIdError: '',
    ticketsConversations: {},


    replyTicketPending: false,
    replyTicketSuccess: false,
    replyTicketError: '',
    replyTickets: {},

    fullNamePending: false,
    fullNameSuccess: false,
    fullNameError: '',
    fullName: ''
}


const ticketReducer = (state = initialState, action: TicketActions) => {
    switch (action.type) {
        case Types.GET_TICKET_BY_USER_REQUEST:
            return {
                ...state,
                getTicketPending: true,
                getTicketSuccess: false,
                getTicketError: '',
                data: [],
            }
        case Types.GET_TICKET_BY_USER_SUCCESS:
            return {
                ...state,
                getTicketPending: false,
                getTicketSuccess: true,
                getTicketError: '',
                data: action.payload.params
            }
        case Types.GET_TICKET_BY_USER_ERROR:
            return {
                ...state,
                getTicketPending: false,
                getTicketSuccess: false,
                getTicketError: '',
                data: action.payload
            }
        case Types.RESET_TICKET_REGISTER:
            return {
                ...state,
                registerTicketPending: false,
                registerTicketSuccess: false,
                registerTicketError: ''
            }



        //************************************************8 */
        case Types.REGISTER_TICKET_REQUEST:
            return {
                ...state,
                registerTicketPending: true,
                registerTicketSuccess: false,
                registerTicketError: ''
            }
        case Types.REGISTER_TICKET_SUCCESS:
            return {
                ...state,
                registerTicketPending: false,
                registerTicketSuccess: true,
                registerTicketError: ''
            }
        case Types.REGISTER_TICKET_ERROR:
            return {
                ...state,
                registerTicketPending: false,
                registerTicketSuccess: false,
                registerTicketError: action.payload
            }
        //*************************************************************** */
        case Types.GET_TICKET_BY_USER_ID_TICKET_REQUEST:
            return {
                ...state,
                getTicketByUserIdPending: true,
                getTicketByUserIdSuccess: false,
                getTicketByUserIdError: '',
                ticketsConversations: {}
            }
        case Types.GET_TICKET_BY_USER_ID_TICKET_SUCCESS:
            return {
                ...state,
                getTicketByUserIdPending: false,
                getTicketByUserIdSuccess: true,
                getTicketByUserIdError: '',
                ticketsConversations: action.payload.params
            }
        case Types.GET_TICKET_BY_USER_ID_TICKET_ERROR:
            return {
                ...state,
                getTicketByUserIdPending: false,
                getTicketByUserIdSuccess: false,
                getTicketByUserIdError: action.payload,

            }
        //**************************************************************** */
        case Types.REPLY_TICKET_REQUEST:
            return {
                ...state,
                replyTicketPending: true,
                replyTicketSuccess: false,
                replyTicketError: '',
                replyTickets: {}
            }
        case Types.REPLY_TICKET_SUCCESS:
            return {
                ...state,
                replyTicketPending: false,
                replyTicketSuccess: true,
                replyTicketError: '',
                replyTickets: action.payload.params
            }
        case Types.REPLY_TICKET_ERROR:
            return {
                ...state,
                replyTicketPending: false,
                replyTicketSuccess: false,
                replyTicketError: action.payload,
            }
        //******************************************************************** */
        case Types.GET_FULL_NAME_REQUEST:
            return {
                ...state,

                fullNamePending: true,
                fullNameSuccess: false,
                fullNameError: '',
                fullName: ''
            }
        case Types.GET_FULL_NAME_SUCCESS:
            return {
                ...state,

                fullNamePending: false,
                fullNameSuccess: true,
                fullNameError: '',
                fullName: action.payload.params
            }
        case Types.GET_FULL_NAME_ERROR:
            return {
                ...state,

                fullNamePending: false,
                fullNameSuccess: false,
                fullNameError: action.payload,

            }



        default:
            return {
                ...state,
            }
    }
}

export default ticketReducer